import { gql } from '@apollo/client';
import { apolloClientWithoutCache } from '../../../apollo';
import {
	STORE_DRILL_DOWN_SALES_METRICS,
	DIMENSION,
	STORE_DRILL_DOWN_INVENTORY_METRICS,
	STORE_DRILL_DOWN_OPD_METRICS,
	STORE_DRILL_DOWN_DIMENSION_METRICS,
	FEDERATED_METRIC_VALUES_V1,
} from '../../../constants';

export const storeDrillDownQueryBuilder = (
	dimension = '',
	threshold = 0,
	period = ''
) => {
	const dimensionsQuery = `dimensions { 
        storeNbr
        dc {
            ${STORE_DRILL_DOWN_DIMENSION_METRICS.join(`
                `)}
        }
    }`;
	const salesQuery = `sales { 
         ${STORE_DRILL_DOWN_SALES_METRICS.join(`
                `)}
    }`;

	const inventoryQuery = `inventory { 
        ${STORE_DRILL_DOWN_INVENTORY_METRICS.join(`
               `)}
   }`;

	const opdQuery = `opd { 
    ${STORE_DRILL_DOWN_OPD_METRICS.join(`
           `)}
}`;

	return `federatedMetricValuesV1(
                input: {
                    attributeFilters: [                        
                        {
                            attribute: "METRIC"
                            name: "replenishableInstock"
                            operator:"LESS_THAN_EQUAL_TO"
                            values: ["${threshold.toString()}"]
                        }
                        {
                            attribute: "DIMENSION"
                            name: "channel"
                            values: $channel
                        }
                        {
                            attribute: "DIMENSION"
                            name: "${dimension}"                           
                            values: $ids
                        }
                    ]
                    timeFilters: [
                        {
                            startDate: $startDate
                            endDate: $endDate
                            period: "${period}"
                        }
                    ]  
                }
            ) 
                { 
                    ... on FederatedMetricValuesConnection {
                        edges {
                            node {
                                ${dimensionsQuery}
                                ${salesQuery}
                                ${inventoryQuery}
                                ${opdQuery}
                            }
                        }
                }
            }`;
};

export const buildStoreDrillDownQuery = (threshold = 0, period = '') => {
	const dimensionQuery = storeDrillDownQueryBuilder(
		DIMENSION.WM_ITEM_NUMBER,
		threshold,
		period
	);

	const query = `
        query federatedMetricValuesV1($startDate: String!, $endDate: String!, $ids: [String], $channel: [String]) {
            ${dimensionQuery}
        }
    `;
	return query;
};

export const fetchStoreDrillMetricsData = (
	payload = { startDate: '', endDate: '', channel: [], ids: [] },
	threshold = 0,
	period = ''
) => {
	const queryStr = buildStoreDrillDownQuery(threshold, period);
	const query = gql`
		${queryStr}
	`;
	return apolloClientWithoutCache.query({
		query,
		context: {
			headers: {
				'x-Apollo-operation-name': FEDERATED_METRIC_VALUES_V1,
			},
		},
		variables: payload,
	});
};
